// "Hot Module Replacement" enabled environment

export const environment = {
    production: false,
    hmr: false,
    isMockEnabled: true,
    appConfig: 'appconfig.hml.json',
    apiCnpj: 'https://api-publica.speedio.com.br/buscarcnpj?cnpj=',
    mercadoPagoApiKey: 'APP_USR-f7c4a0cd-843f-4bfd-8e53-6f651e090694',
    mercadoPagoApi: 'https://api.mercadopago.com/v1/payment_methods/search?public_key',
    secretKeyBry: "/5dKRmUPnFlLgYxn3xUuDlckI6sTs9/o95lgl1FOyRGPY15tRIbSyg==",
    clientIdBry: "0afdc61b-e071-452a-9981-d961cc151448",
    firebaseConfig: {
        apiKey: "AIzaSyDTmTur-WQmdP1CELhXefHhpwbKft0LElU",
        authDomain: "prodigiu-1c383.firebaseapp.com",
        projectId: "prodigiu-1c383",
        storageBucket: "prodigiu-1c383.firebasestorage.app",
        messagingSenderId: "65470390608",
        appId: "1:65470390608:web:8e2cfc07f27f40dd884c55",
        vapidKey: "BBuGW7eDq2THEGVkI0IJg2umxQ1INVYz8SzxLvbZ2ykYdOtxZTM_ATRwTXy9pY3Ld29OryqFu4pVVrBTLKe55CU"
    }

};
